import store from "@/store"

class NacionalidadesService {
  static searchNacionalidadeByName (name = null,campo = null) {
    if (!campo) {
      return store.getters['repositorio/getNacionalidades']
    } else {
      // TODO: melhorar filtragem
      return store.getters['repositorio/getNacionalidades'].filter(nac => removerAcentos(nac[campo]).match(removerAcentos(name.toLowerCase())) || removerAcentos(nac['nome']).toLowerCase().match(removerAcentos(name).toLowerCase()))
    }
  }
}

export default NacionalidadesService
